<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Hoja de usuario</span>
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
      <mat-form-field appearance="outline" class="w-full md:w-auto">
        <mat-label>Documento del usuario</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchString"
          (keyup.enter)="onEnter()"
        />
        <button
          *ngIf="searchString"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchString = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <button
      style="margin-left: 10px"
      (click)="onEnter()"
      mat-raised-button
      color="primary"
    >
      Buscar
    </button>
  
    </div>
  
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
  
    <div
      *ngIf="!isLoadingResults && usuario"
      class="grid grid-cols-2 max-md:grid-cols-1 gap-1 stats-cards apearAnimation"
    >
      <mat-card
      class=" flex justify-self-center justify-center cardHojaUsuario"

      >
        <img [src]="usuario.fotoRefUrl" class="imgFoto" />
      </mat-card>
  
      <mat-card
        class="cardHojaUsuario"
      >
      <h2 class="font-bold">Información del usuario</h2>
        <span> <b> Nombre:</b> {{ usuario.nombre }} </span>
        <span> <b> Documento:</b> {{ usuario.documento }} </span>
        <span>
          <b> Fecha de nacimiento:</b>
          {{ usuario.fechaNacimiento | date : "dd-MM-yyyy" }}
        </span>
        <span>
          <b> Fecha de creación:</b>
          {{ usuario.fechaCreacion | date : "dd-MM-yyyy hh:mm a" }}
        </span>
        <span> <b> RH:</b> {{ usuario.rh }} </span>
        <span> <b> EPS:</b> {{ usuario.eps }} </span>
        <span>
          <b> Fecha ingreso hasta:</b>
          {{ usuario.fechaIngresoHasta | date : "dd-MM-yyyy" }}
        </span>
        <span> <b> Competencia liga:</b> {{ usuario.competenciaLiga?'Si':'No' }} </span>
        <span> <b> Club:</b> {{ usuario.empresa }} </span>
        <span> <b> Alto rendimiento:</b> {{ usuario.altoRendimiento? 'Si': 'No' }} </span>
        <span>
          <b> Fecha de cambio alto rendimiento:</b>
          {{ usuario.fechaCambioAltoRendimiento | date : "dd-MM-yyyy hh:mm a" }}
        </span>
        <span> <b> Disciplina:</b> {{ usuario.disciplina }} </span>
      </mat-card>
  
      <mat-card
        class="cardHojaUsuario"
      >
        <h2 class="font-bold">Últimos ingresos</h2>
  
        <div
          class="divIngreso"
          *ngFor="let item of usuario.ingresos"
          fxLayout="row wrap"
        >
          <div fxFlex="15" fxLayoutAlign="center center">
            <mat-icon aria-hidden="false" style="font-size: x-large"
              >timer</mat-icon
            >
          </div>
          <div fxFlex="85">
            <span
              ><b>Fecha:</b> {{ item.fecha | date : "dd-MM-yyyy hh:mm a" }}
            </span>
            <br />
            <span>
              <b>Resultado:</b> {{ item.resultado ? "Ingresa" : "No ingresa" }}
            </span>
            <br />
  <!--           <span>
              <b> Ingreso extraordinario: </b>
              {{ item.ingresoExtraordinario ? "Si" : "No" }}
            </span> 
            <br />
          -->
            <span *ngIf="!item.resultado">
              <b> Código de no ingreso: </b>
              {{ item.codigoNoIngreso }}
            </span>
            <br *ngIf="!item.resultado" />
            <span *ngIf="item.codigoNoIngreso==1"> <small>El usuario no existe o es un QR obsoleto</small> </span>
            <span *ngIf="item.codigoNoIngreso==2"> <small>El usuario esta bloqueado </small> </span>
            <span *ngIf="item.codigoNoIngreso==3"> <small>El usuario esta inactivo </small> </span>
            <span *ngIf="item.codigoNoIngreso==4"> <small>El usuario no esta asignado a un club </small> </span>
            <span *ngIf="item.codigoNoIngreso==5"> <small>El club esta deshabilitado </small> </span>
            <span *ngIf="item.codigoNoIngreso==6"> <small>El club esta deshabilitado por fecha de servicio </small> </span>
            <span *ngIf="item.codigoNoIngreso==7"> <small>Código no actualizado (pago) </small> </span>
            <span *ngIf="item.codigoNoIngreso==8"> <small>Código ya utilizado para un ingreso </small> </span>
            <span *ngIf="item.codigoNoIngreso==9"> <small>El usuario no tiene disciplina asignada </small> </span>
            <span *ngIf="item.codigoNoIngreso==10"> <small>El usuario no tiene horarios </small> </span>
            <span *ngIf="item.codigoNoIngreso==11"> <small>El usuario no tiene horario para hoy </small> </span>
            <span *ngIf="item.codigoNoIngreso==12"> <small>El usuario registra a una hora no permitida </small> </span>
            <span *ngIf="item.codigoNoIngreso==13"> <small>El horario ya tiene su aforo máximo </small> </span>
            <span *ngIf="item.codigoNoIngreso==14"> <small>El usuario registra despues de finalizar el horario </small> </span>
            <span *ngIf="item.codigoNoIngreso==15"> <small>El usuario registra despues de finalizar el último horario </small> </span>
            <span *ngIf="item.codigoNoIngreso==16"> <small>Error </small> </span>
          </div>
        </div>
      </mat-card>
  
      <mat-card
        class="cardHojaUsuario"
      >
        <h2 class="font-bold">Últimas ordenes de compra</h2>
  
        <div
          class="divIngreso"
          fxLayout="row wrap"
          *ngFor="let item of usuario.detallesOrden"
        >
          <div fxFlex="15" fxLayoutAlign="center center">
            <mat-icon aria-hidden="false" style="font-size: x-large">
              shopping_bag
            </mat-icon>
          </div>
          <div fxFlex="85">
            <span
              ><b>Fecha creación de orden:</b>
              {{ item.fechaCreacionOc | date : "dd-MM-yyyy" }}
            </span>
            <br />
            <span>
              <b>Fecha aceptación de orden:</b>
              {{ item.fechaFinalizadaOc | date : "dd-MM-yyyy hh:mm a" }}
            </span>
            <br />
            <span>
              <b> Estado de la orden: </b>
              {{ item.estadoOc }}
            </span>
  
            <br />
            <span>
              <b> Estado: </b>
              {{ item.estado }}
            </span>
  
            <br />
            <span>
              <b> Valor: </b>
              {{ item.valor | currency : "" : "symbol" : "1.0-0" }}
            </span>
  
            <br *ngIf="item.comentario" />
            <span *ngIf="item.comentario">
              <b> Comentario: </b>
              {{ item.comentario }}
            </span>
  
            <br />
            <span>
              <b> Fecha antes de la orden: </b>
              {{ item.fechaAModificar | date : "dd-MM-yyyy" }}
            </span>
  
            <br />
            <span>
              <b> Fecha despues de la orden: </b>
              {{ item.fechaNueva | date : "dd-MM-yyyy" }}
            </span>
            <br *ngIf="item.Plan" />
            <span *ngIf="item.Plan">
              <b> Plan: </b>
              {{ item.Plan }}
            </span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  